/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Master_DomainInputs */

const en_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master Domain`)
};

const es_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio maestro`)
};

const fr_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine principal`)
};

const de_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master-Domain`)
};

const ja_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マスタードメイン`)
};

const zh_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主域名`)
};

const ar_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النطاق الرئيسي`)
};

const id_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Utama`)
};

const it_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio Principale`)
};

const ru_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основной домен`)
};

const pt_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio Principal`)
};

const ko_master_domain = /** @type {(inputs: Master_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마스터 도메인`)
};

/**
* | output |
* | --- |
* | "Master Domain" |
*
* @param {Master_DomainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const master_domain = /** @type {((inputs?: Master_DomainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Master_DomainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_master_domain(inputs)
	if (locale === "es") return es_master_domain(inputs)
	if (locale === "fr") return fr_master_domain(inputs)
	if (locale === "de") return de_master_domain(inputs)
	if (locale === "ja") return ja_master_domain(inputs)
	if (locale === "zh") return zh_master_domain(inputs)
	if (locale === "ar") return ar_master_domain(inputs)
	if (locale === "id") return id_master_domain(inputs)
	if (locale === "it") return it_master_domain(inputs)
	if (locale === "ru") return ru_master_domain(inputs)
	if (locale === "pt") return pt_master_domain(inputs)
	return ko_master_domain(inputs)
});